/**
* $.fn.player
*
* jQuery unified player plugin
*
* @version v1.0.001, 2013-1-14
* @author Fredi Quirino <fred@firefallpro.com>, Scott Park <scott@firefallpro.com>
* @link http://www.firefallpro.com/
* @license http://www.firefallpro.com/license.txt
* @copyright Copyright (c) 2013 Firefall Pro, LLC
*/
/*jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, sub:true, devel:true, jquery:true, es5:true, indent:4, maxerr:50 */
(function ($) {
	'use strict';
	
	var defaults = {
		'url_html5mediaplayer' : null,
		'url_youtubeplayer' : null,
		'defaults' : {},
		'debug' : false,
		'flash' : false,
		'script_path' : null,
		'plugin_name' : 'jquery.player'
	};
	
	var methods = {
		/**
		* _log
		*
		* Prefixes all debugging logs with plugin name, If IE is present then it opts for using strings when available rather
		* than an object, IE7 and 8 do not show contents of consoled objects. Method concatenates first and second arguments
		* if they're string literals before passing them to console log, otherwise it passes the whole arguments array
		*/
		'_log' : function () {
			if (!$.fn.player.debug) return;
			
			var ie = !$.support.opacity, args = arguments, str = '';
			
			if (ie && typeof arguments[0] === 'string' && typeof arguments[1] === 'string') str = arguments[0] + ' ' + arguments[1];
			else if (ie && typeof arguments[0] === 'string') str = arguments[0];
			
			console.log(defaults['plugin_name'], (ie) ? str : args);
		},
		/**
		* _script_path - Sets the absolute path to the current loaded script or parent script if it was loaded by another plugin
		*
		* @param {object} options Holds the options for player to be created or to be interacted with
		* @returns {string} returns the new absolute path
		*/
		'_script_path' : function (o) {
			// Determine path of current script
			if (o.script_path === null) {
				var $script = $('script[src*="' + o.plugin_name + '"]');
				if ($script.length === 0) return '/';
				return $script[0].src;
			} else {
				var a = document.createElement('a');
				a.href = o.script_path;
				return a.href;
			}
		},
		/**
		* _base_path - Accepts a path and trims the ending, returns the new path.
		*
		* @param {string} path Pathname that will be trimmed
		* @returns {string} returns the new pathname
		*/
		'_base_path' : function (path) {
			return path.substr(0, path.lastIndexOf('/'));
		},
		/**
		* _dependency
		*
		* Helps to load dependencies sequentially, but can also load asynchronous. Key of mapped objects must
		* be the name of the file e.g 'swfobject.js' : {}. Queues dependencies on 'body' and adds the callback
		* if any as the last queued function.
		*
		* @param {object} dependencies An object that holds a map of dependencies that need to be loaded and their settings
		*	@param {boolean} dependencies.async
		*	If 'false' it will load dependencies sequentially and wait until it gets a result before
		*	going on to the next dependency, otherwise if 'true' it will not wait for the results and trigger the next dependency
		*
		*	@param {string} dependencies.url
		*	This is the location to the dependency,  if omitted the url will be constructed using
		*	the path in 'options.script_path' along with the filename/key
		*
		*	@param {function} dependencies.test A function that returns either true or false, used to test if dependency has already been loaded
		*	@param {function} dependencies.callback A function to be called after dependency is loaded successfully
		* @param {object} options Holds the options for player to be created
		* @param {function} callback Supplies a function to be called at completion, optionally
		*/
		'_dependency' : function (dependencies, options, callback) {
			
			var $body = $('body');
			
			$.each(dependencies, function (filename, file) {
				
				// Dependency state
				if (typeof dependency[filename] === 'undefined') dependency[filename] = 0;
				
				// Check if already loaded
				if (dependency[filename] === 2 || file.test()) {
					methods._log(filename + ' is already loaded');
					dependency[filename] = 2;
					if (typeof file.callback !== 'undefined') file.callback();
					return;
				}
				
				// URL
				if (file.url === null) file.url = methods._base_path(options.script_path) + '/' + filename;
				
				methods._log('load script at ' + file.url);
				
				// Queue
				$body.queue('player', function (next) {
					
					if (dependency[filename] === 0) {
						// Signal loading
						methods._log('Loading ' + filename);
						
						dependency[filename] = 1;
						
						// Load Script
						dependency[filename + '_promise'] = $.ajax({
							'cached' : true,
							'dataType' : 'script',
							'error' : function () {
								$.error('Failed to load dependency: ' + file.url);
							},
							'success' : function () {
								methods._log(filename + ' loaded');
								
								dependency[filename] = 2;
								if (typeof file.callback !== 'undefined') file.callback();
								if (!file.async) next();
							},
							'url' : file.url
						});
						if (file.async) next();
						return;
					}
					
					methods._log(filename + 'has already been started');
					
					dependency[filename + '_promise'].done(function () {
						methods._log(filename + ' loaded');
						if (typeof file.callback !== 'undefined') file.callback();
					});
					
					if (file.async) next();
					
				});
			});
			
			// Queue callback if set
			if (typeof callback !== 'undefined') {
				$body.queue('player', function (next) {
					methods._log('Queue is complete');
					
					callback();
					next();
				});
			}
			
			// Start queue
			$body.dequeue('player');
		},
		/**
		* init
		*
		* initiates dependencies and scope, finds all native video sources or youtube sources in the href of links inside
		* of the element that calls on 'init'. Gets an absolute path to dependencies using the path in the script tag and
		* sequentially loads dependencies after each one. Binds onclick to trigger either youtube or html5media plugin.
		*
		* @param {string} args 
		* @param {object} options Holds the options for player to be created or to be interacted with
		* @param {function} callback Supplies a function to be called at completion, optionally
		* @returns {obect} returns jQuery object
		*/
		'init' : function (args, options, callback) {
			
			// Merge options with defaults
			var option = $.extend(true, {}, defaults, options);
			
			// Toggle debug
			if (option['debug']) $.fn.player.debug = true;
			
			var result = this;
			
			
			this.each(function () {
				methods._log('Initializing scope');
				
				var $link = {}, selector = $(this), dependencies = {};
				
				// Video Links
				$link['youtube'] = $('a.video[href*="youtube.com/"], a[href*="youtu.be/"]', selector).addClass('video_youtube');
				$link['html5media'] = $('a.video[href*=".mp4"], a[href*=".webm"], a[href*=".ogg"], a[href*=".ogv"], a[href*=".theora.ogg"], a[href*="theora.ogv"]', selector).addClass('video_html5media');
				
				// Attach user specified options
				if (!$.isEmptyObject(option['defaults'])) {
					$link['youtube'].data(option['defaults']);
					$link['html5media'].data(option['defaults']);
				}
				
				dependencies = {
					'jquery.player.youtube.min.js' : {
						'url' : option['url_youtubeplayer'],
						'async' : false,
						'test' : function () { return (typeof $.fn.youtubeplayer !== 'undefined'); }
					},
					'jquery.player.html5media.min.js' : {
						'url' : option['url_html5mediaplayer'],
						'async' : false,
						'test' : function () { return (typeof $.fn.html5mediaplayer !== 'undefined'); }
					}
				};
			
				// Load Dependencies
				if ($link['youtube'].length === 0) delete dependencies['jquery.player.youtube.min.js'];
				if ($link['html5media'].length === 0) delete dependencies['jquery.player.html5media.min.js'];
					
				// Validate script path is not null
				option['script_path'] = methods['_script_path'](option);
				
				methods._log('script_path is', option['script_path']);
				
				// Load dependencies
				methods['_dependency'](dependencies, option);
				
				// YouTube Links
				$link['youtube'].on('click', function (e) {
					e.preventDefault();
					var $target = $(this.hash);
					methods._log('Youtube link clicked ' + this.href);
					
					// Rebuild url without hash
					var url = this.protocol + this.host + this.pathname + this.search;
					
					// New player
					if (typeof $target.data('player') === 'undefined') {
						methods._log('Initializing new player', $(this).data());
						$target.youtubeplayer(url, $.extend({}, $(this).data(), option)).addClass('video');
						
					// Existing player
					} else {
						methods._log('Existing player available');
						$target.youtubeplayer('cue', url);
						if ($(this).data('autoplay')) $target.youtubeplayer('play');
						$target.trigger('init.player');
					}
					
				});
				
				// Native Video Links
				$link.html5media.on('click', function (e) {
					e.preventDefault();
					var $target = $(this.hash);
					methods._log('html5media link clicked ' + this.href);
					
					// Existing player
					if (typeof $target.data('player') !== 'undefined') {
						methods._log('Existing player found');
						
						$target.html5mediaplayer('destroy');
					}
					
					methods._log('Initializing new player', $(this).data());
					$target.html5mediaplayer('player', this.href, $.extend($(this).data(), option)).addClass('video');
				});
				
				result = selector;
			});
			
			if (typeof callback !== 'undefined') callback.call(this);
			return result;
		}
	};
	
	$.fn.player = function () {
		var fn, args, settings = {}, callback, results;
		
		// Assign arguments
		for (var i = 0; i < arguments.length; i++) {
			switch (typeof arguments[i]) {
			
			// Callback
			case 'function':
				callback = arguments[i];
				break;
			
			// Settings
			case 'object':
				settings = arguments[i];
				break;
			
			// Ignore undefined
			case 'undefined':
				break;
			
			// Function or Argument
			case 'string':
			default:
				if (methods[arguments[i]]) fn = arguments[i];
			}
		}
		
		// Initialize
		if (methods[fn]) {
			methods._log(fn);
			methods[fn].call(this, args, settings, callback);
			
		// html5media
		} else if (typeof this.data('player') !== 'undefined' && this.data('player')['type'] === 'html5media') {
			results = this.html5mediaplayer.apply(this, arguments);
		
		// youtube
		} else if (typeof this.data('player') !== 'undefined' && this.data('player')['type'] === 'youtube') {
			results = this.youtubeplayer.apply(this, arguments);
		}
		
		return typeof results !== 'undefined' ? results : this;
	};
	
	// Dependency tracker
	var dependency = $.fn.player.dependencies = {};
	
	// Debug state
	$.fn.player.debug = false;
})(jQuery);
